import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IBaseWrapper, IDataLogin } from '@core/api-types/user';
import { LocalStorageJwtService } from '@core/services/localstoragejwt.service';
import { environment } from 'environments/environment';
import { Observable, of, switchMap } from 'rxjs';

export interface IAccountRegister {
    Username: string;
    Fullname: string;
    Password: string;
    Userphone: string;
    UserEmail: string;
    Level: string;
    LstPermission?: string[];
    Status?: number;
}
@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private httpClient: HttpClient, private router: Router) {}

    login(account: {
        username: string;
        password: string;
    }): Observable<IBaseWrapper<IDataLogin>> {
        return this.httpClient.post<IBaseWrapper<IDataLogin>>(
            environment.BASE_API + '/api/v1/auth/login',
            account
        );
    }

    logout(isNavigateSignInPage = false): Observable<any> {
        return this.httpClient
            .get<any>(environment.BASE_API + '/api/v1/auth/logout')
            .pipe(
                switchMap(() => {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('jwtToken');
                    localStorage.clear();
                    if (isNavigateSignInPage) {
                        this.router.navigateByUrl('/sign-in');
                    }
                    return of(true);
                })
            );
    }

    signUp(body: IAccountRegister): Observable<any> {
        return this.httpClient.post<any>(
            environment.BASE_API + '/api/v1/Register',
            body
        );
    }

    editUser(body: IAccountRegister): Observable<any> {
        return this.httpClient.put<any>(
            environment.BASE_API + '/api/v1/EditUser',
            body
        );
    }

    getUsers(payloadSearch: any): Observable<any> {
        return this.httpClient.post<Observable<any>>(
            `${environment.BASE_API}/api/v1/CustomSearch/User`,
            payloadSearch
        );
    }

    removeUser(username: string): Observable<any> {
        return this.httpClient.delete<Observable<any>>(
            `${environment.BASE_API}/api/v1/DelUser/${username}`
        );
    }

    getSession(payloadSearch: any): Observable<any> {
        return this.httpClient.post<Observable<any>>(
            `${environment.BASE_API}/api/v1/CustomSearch/Session`,
            payloadSearch
        );
    }
}
